<section class="w-full w-23rem sm:max-w-30rem sm:w-30rem relative flex flex-column gap-3 pb-3 px-3">
  <section class="w-full">
    <h3 class="ci-txt-body text-xl xl:text-2xl font-bold ci-txt--black">
      {{ mapInfo?.title }}
    </h3>

    <section *ngIf="mapInfo?.description">
      <p class="ci-txt-body text-sm ci-txt--black-lighten mt-3">
        {{mapInfo?.description}}
      </p>
    </section>
  </section>

  <section class="w-full h-30rem pb-3">
    <article class="w-full h-full fadein animation-duration-100 relative overflow-hidden border-round-xl shadow-1">
      <section [id]="mapId" class="w-full h-full z-3"></section>
    </article>
  </section>
</section>